import React from "react";
import { Eye, Trash } from "@phosphor-icons/react";
import ImageLoader from "./loader/ImageLoader";

const SLOT_LABELS = ["Front", "Back"];

export default function VerificationIdSlots({ slots, onSelectFile, onClear, onPreview, disabled, readOnly }) {
    return (
        <div className="mt-2 flex gap-2">
            {slots.map((slot, index) => (
                <div className="flex-1 text-center" key={SLOT_LABELS[index]}>
                    {slot.loading ? (
                        <ImageLoader />
                    ) : slot.url ? (
                        <div
                            className="w-full h-[150px] relative bg-cover bg-center bg-no-repeat rounded-lg"
                            style={{ backgroundImage: `url(${slot.url})` }}
                        >
                            <div className="absolute inset-0 flex gap-3 items-center justify-center">
                                <button
                                    type="button"
                                    className="bg-[#e9e8e8] rounded py-1 px-2 cursor-pointer shadow-md"
                                    onClick={() => onPreview(slot.url)}
                                >
                                    <Eye size={16} color="blue" />
                                </button>
                                {!readOnly && (
                                    <button
                                        type="button"
                                        className="bg-[#e9e8e8] rounded py-1 px-2 cursor-pointer shadow-md disabled:opacity-50"
                                        disabled={disabled}
                                        onClick={() => onClear(index)}
                                    >
                                        <Trash size={16} color="red" />
                                    </button>
                                )}
                            </div>
                        </div>
                    ) : readOnly ? (
                        <div className="mb-2 bg-[#EEF0FB] border border-dashed border-[#BFC4CC] flex items-center justify-center w-full h-[150px] rounded-lg">
                            <span className="text-xs text-[#8C9199]">Not uploaded</span>
                        </div>
                    ) : (
                        <label
                            className={`mb-2 bg-gray-300 flex items-center justify-center w-full h-[150px] rounded-lg shadow-md ${
                                disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"
                            }`}
                        >
                            <span className="text-[40px] text-white font-bold">+</span>
                            <input
                                type="file"
                                accept="image/jpeg,image/png,image/webp"
                                className="hidden"
                                disabled={disabled}
                                onChange={(event) => onSelectFile(index, event)}
                            />
                        </label>
                    )}
                    <span className="font-semibold text-gray-600">{SLOT_LABELS[index]}</span>
                </div>
            ))}
        </div>
    );
}
